import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LotDetailMainComponent } from './lot-detail-main.component';
import { BasicDetailsPaneComponent } from './basic-details-pane.component';
import { LOT_DETAIL_ROUTES } from './lot-detail.route';
import { LotDetailContext } from './lot-detail.context';
import { FilesPaneComponent } from './files-pane.component';
import { LotSourcePaneComponent } from './lot-source-pane.component';
import { BmsjHipsterSharedModule } from '../../shared';
import { LotAttributeContext } from './attributes/lot-attribute.context';
import { LotAttributesPaneComponent } from './lot-attributes-pane.component';
import { TruncateSpanComponent } from '../../shared/util/span-truncate/truncate-span.component';
import { LotAttributeModalComponent } from './attributes/lot-attribute-modal.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...LOT_DETAIL_ROUTES]),
        TruncateSpanComponent
    ],
    declarations: [
        BasicDetailsPaneComponent,
        LotDetailMainComponent,
        LotSourcePaneComponent,
        FilesPaneComponent,
        LotAttributeModalComponent,
        LotAttributesPaneComponent
    ],
    providers: [
        LotDetailContext,
        LotAttributeContext
    ]
})
export class LotDetailModule {

}
